import {
  MariaDBLogo,
  MySQLLogo,
  PostgreSQLLogo,
  RedisLogo,
  ValkeyLogo,
} from '@/logos'

const DatabaseType = {
  Mariadb: 'mariadb',
  Mongodb: 'mongodb',
  Mysql: 'mysql',
  Postgresql: 'postgresql',
  Redis: 'redis',
  Valkey: 'valkey',
}

export const databases = {
  [DatabaseType.Mariadb]: {
    name: 'MariaDB',
    type: DatabaseType.Mariadb,
    icon: MariaDBLogo,
  },
  [DatabaseType.Mysql]: {
    name: 'MySQL',
    type: DatabaseType.Mysql,
    icon: MySQLLogo,
  },
  [DatabaseType.Postgresql]: {
    name: 'PostgreSQL',
    type: DatabaseType.Postgresql,
    icon: PostgreSQLLogo,
  },
  [DatabaseType.Redis]: {
    name: 'Redis',
    type: DatabaseType.Redis,
    icon: RedisLogo,
  },
  [DatabaseType.Valkey]: {
    name: 'Valkey',
    type: DatabaseType.Valkey,
    icon: ValkeyLogo,
  },
}
